import { StateNode, TLEventHandlers, TLGroupShape } from '@tldraw/tldraw'
import { getMaskingShapeId, setMaskingShapeId } from 'components/VisualStudioPlayground/VisualEditor/helpers'
import { getHitShapeOnCanvasPointerDown } from './getHitShapeOnCanvasPointerDown'

export class Idle extends StateNode {
  static override id = 'idle'

  override onEnter = () => {
    this.editor.updateInstanceState({ cursor: { type: 'default', rotation: 0 } }, { ephemeral: true })

    const onlySelectedShape = this.editor.getOnlySelectedShape()

    if (onlySelectedShape) {
      this.editor.mark('mask')
      setMaskingShapeId(this.editor, onlySelectedShape.id)
    }
  }

  override onPointerDown: TLEventHandlers['onPointerDown'] = (info) => {
    switch (info.target) {
      case 'canvas': {
        const hitShape = getHitShapeOnCanvasPointerDown(this.editor)
        if (hitShape && !this.editor.isShapeOfType<TLGroupShape>(hitShape, 'group')) {
          this.onPointerDown({
            ...info,
            shape: hitShape,
            target: 'shape',
          })
          return
        }

        this.cancel()
        // feed the event back into the statechart
        this.editor.root.handleEvent(info)
        break
      }
      case 'shape': {
        const maskingShapeId = getMaskingShapeId(this.editor)
        if (info.shape.id === maskingShapeId) {
          this.editor.setCurrentTool('select.mask.pointing_content', info)
        } else {
          // TODO: Maybe implement a `canMask` method on the shape util instead of
          // hardcoding the type here
          if (info.shape.type === 'mask') {
            setMaskingShapeId(this.editor, info.shape.id)
            this.editor.setSelectedShapes([info.shape.id])
            this.editor.setCurrentTool('select.mask.pointing_content', info)
          } else {
            this.cancel()
            // feed the event back into the statechart
            this.editor.root.handleEvent(info)
          }
        }
        break
      }
      case 'selection': {
        switch (info.handle) {
          case 'mobile_rotate':
          case 'top_left_rotate':
          case 'top_right_rotate':
          case 'bottom_left_rotate':
          case 'bottom_right_rotate': {
            // TODO: implement rotation
            break
          }
          case 'top':
          case 'right':
          case 'bottom':
          case 'left': {
            this.editor.setCurrentTool('select.pointing_mask_handle', {
              ...info,
              onInteractionEnd: 'select.mask',
            })
            break
          }
          case 'top_left':
          case 'top_right':
          case 'bottom_left':
          case 'bottom_right': {
            // TODO: force aspect ratio lock
            this.editor.setCurrentTool('select.pointing_mask_handle', {
              ...info,
              onInteractionEnd: 'select.mask',
            })
            break
          }
          default: {
            this.cancel()
          }
        }
        break
      }
    }
  }

  override onCancel: TLEventHandlers['onCancel'] = () => {
    this.cancel()
  }

  private cancel() {
    setMaskingShapeId(this.editor, null)
    this.editor.setCurrentTool('select.idle', {})
  }
}
